/** API route map: URLS.Controller.ClientProfile */
export const ClientProfile = {
      Name: 'ClientProfile/',
      GetClientProfile: 'get-client-header-summary',
      updateClient: 'update-client',
      updateClientSocialMedia: 'update-client-social-media',
      GetClientAssignedBadges: 'get-client-badges',
      GetClientContacts: 'get-client-contacts-main',
      GetBadgesUsingClient: 'get-badges-using-client',
      UpdateAssignedBadges: 'update-assigned-badges-client',
      GetBadgesForBulk: 'get-badges-for-bulk',
      AddBadgesBulk: 'add-bulk-badge',
      AddVisibilityBulk: 'add-bulk-visibility',
      AddOnboardingBulk: 'add-bulk-onboarding-status',
      AddOwnerBulk: 'add-bulk-owner',
      CheckClientExist: 'check-client-exist',
      GetJobCount: 'get-jobs-count',
      AddClientDescription: 'add-client-description',
      GetAllClientW2Form: 'get-all-client-W2Form',
      GetEmployeeCount: 'get-employee-count',
      updateClientSelfRepresentative: 'update-client-self-representative',
      AddSelfRepExistingClient: 'add-self-representative-existing-client',
      GetAllClientW2CForm: 'get-all-client-W2CForm',
      GetSubClientsW2Form: 'get-sub-clients-W2Form',
      GetSubClientsW2CForm: 'get-sub-clients-W2CForm',
      GetEmployeesByClients: 'get-employees-by-clients-W2Form',
      GetEmployeesByClientsW2C: 'get-employees-by-clients-W2CForm',
      Set1099FormDate: 'set-1099Form-Date',
};
